<script lang="ts">
    import type { UserMessageCarrier } from "@app/models/api";
    import { delayPromise } from "@app/services/delay-promise";
    import { getUserMesageDetails } from "@app/services/glosbe-dictionary-api/get-messages";
    import { getMessage } from "@app/services/i18n.service";
    import { slide } from "svelte/transition";
    import ExpandDown from "../Icons/ExpandDown.svelte";
    import LoadingInProgress from "../LoadingInProgress.svelte";
    import { updateUnreadMessagesCount } from "./NotificationsService";
    export let message: UserMessageCarrier;
    export let isFirst: boolean = false;

    let messageDetailsPromise: Promise<UserMessageCarrier>;
    let messageExpanded = false;
    let isNewMessage = false;
    function updateIsNewMessage() {
        isNewMessage =
            !message.firstReadDate &&
            !messageExpanded &&
            !messageDetailsPromise;
    }
    updateIsNewMessage();
    function toggleMessageDetails() {
        if (messageExpanded) {
            messageExpanded = false;
        } else {
            messageExpanded = true;
            if (!messageDetailsPromise) {
                messageDetailsPromise = delayPromise(
                    getUserMesageDetails(message.id),
                    500
                );
                if (isNewMessage) {
                    messageDetailsPromise.then(updateUnreadMessagesCount);
                }
                updateIsNewMessage();
            }
        }
    }

    function getMessageCreatedDateString() {
        const createdDate = new Date(message.createdDate);
        return `${createdDate.toLocaleString()}`;
    }
</script>

<div class="border-b border-gray-300" class:border-t={isFirst}>
    <button
        class="pt-2 pointer w-full text-align-reset overflow-hidden {!messageExpanded
            ? 'hover:bg-tertiary-100'
            : 'bg-slate-100'} "
        on:click={toggleMessageDetails}
    >
        <div class="flex items-start">
            <div
                class="w-full text-gray-800 text-base px-1"
                class:truncate={!messageExpanded}
                class:font-bold={isNewMessage}
            >
                {#if isNewMessage}
                    <div class="rounded-full bg-tertiary-600 shadow inline-block new-message-marker mx-1"></div>
                {/if}
                {message.title}
            </div>
            <div
                class="expand-btn duration-150 transform-all text-center pt-1"
                class:expanded={messageExpanded}
            >
                <ExpandDown />
            </div>
        </div>
        <div class="text-gray-500 text-xxs py-2 px-1">
            {getMessageCreatedDateString()}
            <div class="dir-aware-float-right">
                {#await messageDetailsPromise}
                    <LoadingInProgress />
                {/await}
            </div>
        </div>
    </button>
    {#if messageExpanded}
        {#await messageDetailsPromise then messageDetails}
            <div class="flex">
                <p
                    class="message-content message-body pb-4 pt-1 text-sm text-gray-700 px-1"
                    transition:slide
                >
                    {messageDetails.body}
                </p>
            </div>
        {/await}
    {/if}
</div>

<style>
    .expanded {
        transform: rotateX(180deg);
    }
    .message-body {
        white-space: pre-line;
    }
    .expand-btn {
        width: 2rem;
    }
    .new-message-marker {
        width: .75rem;
        height: .75rem;
    }
</style>
